/* eslint-disable */
import React from 'react';
import { Input, Radio, Button, Popconfirm } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

import { ContentItem, DictionaryContent } from '../styles';

function SingleDictionaryContent({
    selectedDictionary,
    searchText,
    setSearchText,
    selectedKey,
    handleKeySelect,
    dataType,
    setDataType,
    onDetach,
}) {
    if (!selectedDictionary) {
        return <div style={{ padding: '16px', textAlign: 'center', color: '#999' }}>Справочник не найден или был удалён</div>;
    }

    const content = selectedDictionary.content || {};
    const entries = Object.entries(content);

    if (entries.length === 0) {
        return <div style={{ padding: '16px', textAlign: 'center' }}>Справочник пустой</div>;
    }

    const filteredEntries = entries.filter(([key, value]) => {
        const searchLower = searchText.toLowerCase();
        const keyMatch = key.toLowerCase().includes(searchLower);
        const valueStr = typeof value === 'object' ? JSON.stringify(value) : String(value);
        const valueMatch = valueStr.toLowerCase().includes(searchLower);
        return keyMatch || valueMatch;
    });

    return (
        <div>
            {selectedKey && (
                <div
                    style={{
                        marginBottom: 12,
                        padding: 12,
                        background: '#e6f7ff',
                        border: '1px solid #91d5ff',
                        borderRadius: 4,
                    }}
                >
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                        <div style={{ fontWeight: 'bold', color: '#1890ff' }}>
                            Выбранное значение:
                        </div>
                        {onDetach && (
                            <Popconfirm
                                title="Открепить значение?"
                                description="Привязка к этому справочнику будет удалена."
                                onConfirm={onDetach}
                                okText="Да, открепить"
                                cancelText="Отмена"
                            >
                                <Button danger size="small">
                                    Открепить
                                </Button>
                            </Popconfirm>
                        )}
                    </div>
                    <div style={{ marginBottom: 4 }}>
                        <strong>{selectedKey}:</strong>
                        {' '}
                        {dataType === 'key'
                            ? selectedKey
                            : (typeof content[selectedKey] === 'object'
                                ? JSON.stringify(content[selectedKey])
                                : String(content[selectedKey])
                            )
                        }
                    </div>
                    <div style={{ fontSize: '12px', color: '#666' }}>
                        Сохранить:
                        <Radio.Group
                            size="small"
                            value={dataType}
                            onChange={(e) => setDataType(e.target.value)}
                            style={{ marginLeft: 8 }}
                        >
                            <Radio.Button value="key">Ключ</Radio.Button>
                            <Radio.Button value="value">Значение</Radio.Button>
                        </Radio.Group>
                    </div>
                </div>
            )}

            <DictionaryContent>
                <div style={{ marginBottom: '16px' }}>
                    <h4 style={{ marginBottom: '12px' }}>
                        Содержимое справочника:
                        {' '}
                        {selectedDictionary.name}
                    </h4>
                    <Input
                        placeholder="Поиск по ключу или значению..."
                        prefix={<SearchOutlined />}
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        allowClear
                    />
                </div>
                {filteredEntries.length === 0 ? (
                    <div style={{ padding: '16px', textAlign: 'center', color: '#999' }}>
                        Ничего не найдено
                    </div>
                ) : (
                    filteredEntries.map(([key, value]) => (
                        <ContentItem
                            key={key}
                            selected={selectedKey === key}
                            onClick={() => handleKeySelect(key)}
                        >
                            <div>
                                <strong>Ключ:</strong>
                                {' '}
                                {key}
                            </div>
                            <div>
                                <strong>Значение:</strong>
                                {' '}
                                {typeof value === 'object' ? JSON.stringify(value) : String(value)}
                            </div>
                        </ContentItem>
                    ))
                )}
            </DictionaryContent>
        </div>
    );
}

export default SingleDictionaryContent;
